const APP_NAME = "YFlow Survey";
const BRAND = "YFlow";
const VERSION = "0.0.1";
const BASE_URL = "https://survey.yflow.io";

export { APP_NAME, BRAND, VERSION, BASE_URL };
